import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
    { ...generateImportColumn("", `code`), pinned: "left", ...importErrorFunction() },
    { ...generateImportColumn("", `career_level`), ...importErrorFunction() },
    { ...generateImportColumn("", `industry_name`), ...importErrorFunction() },
    { ...generateImportColumn("", `careers`), ...importErrorFunction() },
    { ...generateImportColumn("", `education_training`), ...importErrorFunction() },
    { ...generateImportColumn("", `education_level`), ...importErrorFunction() },
    { ...generateImportColumn("", `experience`), ...importErrorFunction() },
    { ...generateImportColumn("", `experience_level`), ...importErrorFunction() },
  ];
export default columnDefs;
